module.exports = __webpack_public_path__ + "img/7.ca9f7e5.png";